export default __webpack_public_path__ + "static/media/3.cca0d6b3.png";